import createReactComponent from '../createReactComponent';
export default createReactComponent('outline', 'cross', 'IconCross', [["path",{"d":"M10 21h4v-9h5v-4h-5v-5h-4v5h-5v4h5z","key":"svg-0"}]]);